<template>
  <div class="banner-config">
    <!-- 顶部筛选区 -->
    <div class="filter-bar f--c">
      <el-input
        v-model="searchParams.bannerName"
        placeholder="请输入Banner名称"
        clearable
        size="medium"
        style="width: 200px; margin-right: 10px"
        @blur="handleSearch"
        @clear="handleSearch"
      />
      <el-select
        v-model="searchParams.status"
        placeholder="请选择状态"
        clearable
        size="medium"
        style="width: 150px; margin-right: 10px"
        @change="handleSearch"
        @clear="handleSearch"
      >
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button type="primary" size="medium" @click="handleSearch">查询</el-button>
      <el-button type="success" size="medium" @click="handleAdd">新增Banner配置</el-button>
    </div>

    <!-- 列表 -->
    <el-table
      ref="bannerTable"
      v-loading="loading"
      :data="tableData"
      style="width: 100%;"
      row-key="id"
      height="calc(100vh - 250px)"
    >
      <el-table-column label="排序" width="80" align="center">
        <template>
          <i class="el-icon-rank pointer cursor-move" style="font-size: 20px; color: #909399" />
        </template>
      </el-table-column>
      <el-table-column label="Banner图片" width="120" align="center">
        <template slot-scope="{ row }">
          <el-image
            v-if="row.imgUrl"
            :src="row.imgUrl"
            :preview-src-list="[row.imgUrl]"
            fit="cover"
            style="width: 100px; height: 50px; cursor: pointer"
          />
        </template>
      </el-table-column>
      <el-table-column prop="bannerName" label="Banner名称" min-width="150" />
      <el-table-column label="链接" min-width="200">
        <template slot-scope="{ row }">
          <span v-if="row.linkUrl" class="ellipsis" :title="row.linkUrl">{{ row.linkUrl }}</span>
          <span v-else style="color: #909399">未设置</span>
        </template>
      </el-table-column>
      <el-table-column label="PDF文件" min-width="150">
        <template slot-scope="{ row }">
          <span v-if="row.pdfUrl" class="ellipsis" :title="row.pdfName">{{ row.pdfName }}</span>
          <span v-else style="color: #909399">未设置</span>
        </template>
      </el-table-column>
      <el-table-column label="页面类型" min-width="150">
        <template slot-scope="{ row }">
          <span v-if="row.bannerType === 1" style="color: #409eff">ABOUT US</span>
          <span v-else style="color: #909399">Banner</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="{ row }">
          <el-switch
            v-model="row.status"
            :active-value="1"
            :inactive-value="0"
            @change="handleStatusChange(row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="handleEdit(row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <!-- <div class="footer">
      <el-pagination
        background
        :current-page="pagination.pageNumber"
        :page-sizes="[20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
      />
    </div> -->

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form ref="bannerForm" :model="formData" :rules="formRules" label-width="100px">
        <el-form-item label="Banner名称" prop="bannerName">
          <el-input
            v-model="formData.bannerName"
            placeholder="请输入Banner名称(仅支持英文和数字)"
            maxlength="50"
            size="medium"
            @blur="handleBlur"
          />
        </el-form-item>
        <el-form-item label="Banner图片" prop="imgUrl">
          <el-upload
            ref="imageUpload"
            action="#"
            :show-file-list="false"
            :auto-upload="false"
            accept="image/png,image/jpg,image/jpeg"
            :on-change="handleImageChange"
          >
            <div v-if="formData.imgUrl" class="image-preview">
              <img :src="formData.imgUrl" />
              <div class="image-mask">
                <i class="el-icon-edit" />
                <!-- <i class="el-icon-delete" @click.stop="handleRemoveImage" /> -->
              </div>
            </div>
            <div v-else class="upload-placeholder">
              <i class="el-icon-plus" />
              <div>上传图片</div>
              <div>支持png、jpg格式，大小不超过3M</div>
            </div>
          </el-upload>
          <div class="upload-tip">banner推荐尺寸（3560 × 960）</div>
          <div class="upload-tip">about推荐尺寸（1780 × 614）</div>
        </el-form-item>
        <el-form-item label="跳转设置">
          <el-radio v-model="formData.linkType" :disabled="formData.bannerType === 1" :label="1">链接地址</el-radio>
          <el-radio v-model="formData.linkType" :disabled="formData.bannerType === 1" :label="2">上传PDF</el-radio>
        </el-form-item>
        <el-form-item v-if="formData.linkType === 1" label="链接地址" prop="linkUrl">
          <el-input
            v-model.trim="formData.linkUrl"
            placeholder="请输入链接地址"
            size="medium"
            :disabled="formData.bannerType === 1"
          />
        </el-form-item>
        <el-form-item v-if="formData.linkType === 2" label="上传PDF" prop="pdfUrl">
          <el-upload
            ref="pdfUpload"
            action="#"
            :show-file-list="false"
            :auto-upload="false"
            accept=".pdf"
            :on-change="handlePdfChange"
          >
            <el-button size="small" type="primary">
              {{ formData.pdfUrl ? '重新上传' : '选择文件' }}
            </el-button>
            <span v-if="formData.pdfName" style="margin-left: 10px">{{ formData.pdfName }}</span>
          </el-upload>
          <div class="upload-tip">支持pdf格式</div>
        </el-form-item>
        <el-form-item label="启用状态" prop="status">
          <el-switch
            v-model="formData.status"
            :active-value="1"
            :inactive-value="0"
            active-text="启用"
            inactive-text="禁用"
          />
        </el-form-item>
        <el-form-item label="页面类型">
          <el-checkbox :value="formData.bannerType === 1" :disabled="dialogTitle.includes('编辑')" @change="handleBannerTypeChange">是否配置为ABOUT US</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="medium" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" size="medium" :loading="submitLoading" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from '@/api'
import { Sortable } from 'sortablejs'

export default {
  name: 'BannerConfig',
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入Banner名称'))
      } else if (!/^[a-zA-Z0-9\s_]+$/.test(value)) {
        callback(new Error('仅支持英文和数字'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      searchParams: {
        bannerName: '',
        status: undefined, // 启用状态：0-停用 1-启用（不传查全部）
        // bannerType: 0 //Banner类型：0-banner 1-about_us
      },
      tableData: [],
      pagination: {
        pageNumber: 1,
        pageSize: 20,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '新增Banner配置',
      submitLoading: false,
      formData: {
        id: null,
        bannerType: 0,
        bannerName: '',
        imgUrl: '',
        linkType: 1,
        linkUrl: '',
        pdfUrl: '',
        pdfName: '',
        status: 1
      },
      formRules: {
        bannerName: [{ required: true, validator: validateName, trigger: 'blur' }],
        imgUrl: [{ required: true, message: '请上传Banner图片', trigger: 'change' }]
      },
      sortable: null
    }
  },
  mounted() {
    this.getList()
    this.initSortable()
  },
  beforeDestroy() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  },
  methods: {
    // 获取列表
    getList() {
      this.loading = true
      const params = {
        ...this.searchParams,
        // pageNumber: this.pagination.pageNumber,
        // pageSize: this.pagination.pageSize
      }
      API.getLaunchBannerList(params).then(res => {
        this.tableData = res.data || []
        // this.pagination.total = res.data.total || 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },

    // 初始化拖拽排序
    initSortable() {
      this.$nextTick(() => {
        const el = this.$refs.bannerTable.$el.querySelector('.el-table__body-wrapper tbody')
        this.sortable = Sortable.create(el, {
          handle: '.el-icon-rank',
          animation: 150,
          onEnd: ({ oldIndex, newIndex }) => {
            if (oldIndex === newIndex) return
            const movedItem = this.tableData.splice(oldIndex, 1)[0]
            this.tableData.splice(newIndex, 0, movedItem)
            this.updateSort()
          }
        })
      })
    },

    // 更新排序
    updateSort() {
      const sortData = this.tableData.map((item, index) => ({
        id: item.id,
        sort: index + 1
      }))
      API.sortLaunchBanner({
        ids: sortData.map(item => item.id)
      }).then(() => {
        this.$message.success('排序更新成功')
      })
    },

    // 查询
    handleSearch() {
      this.pagination.pageNumber = 1
      this.getList()
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增Banner配置'
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑Banner配置'
      this.formData = { ...row }
      this.dialogVisible = true
    },

    handleBlur() {
      // 失去焦点去除前后空格
      this.formData.bannerName = this.formData.bannerName.trim()
    },

    handleBannerTypeChange(value) {
      this.formData.bannerType = value ? 1 : 0
      if (this.formData.bannerType) {
        this.formData.linkType = 1
        // 判断当前环境是正式环境
        if (process.env.NODE_ENV === 'production') {
          this.formData.linkUrl = 'https://www.kakaclo.com/aboutus'
        } else {
          this.formData.linkUrl = 'https://kakatest.com/aboutus'
        }
        // this.formData.linkUrl = 'https://www.baidu.com'
      }
    },

    // 状态切换
    handleStatusChange(row) {
      API.editLaunchBannerStatus({ id: row.id, status: row.status }).then(() => {
        this.$message.success('状态更新成功')
        this.getList()
      }).catch(() => {
        row.status = row.status === 1 ? 0 : 1
      })
    },

    // 图片上传
    handleImageChange(file) {
      const isImage = ['image/png', 'image/jpg', 'image/jpeg'].includes(file.raw.type)
      const isLt3M = file.size / 1024 / 1024 < 3

      if (!isImage) {
        this.$message.error('只支持png、jpg格式的图片')
        return
      }
      if (!isLt3M) {
        this.$message.error('图片大小不能超过3M')
        return
      }

      API.signValue({ directory: 'pushBanner/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'pushBanner/')
        formData.append('signValue', data)
        formData.append('fileList', file.raw)
        API.uploadFile(formData).then(result => {
          this.formData.imgUrl = result.data
          this.$refs.bannerForm.clearValidate('imgUrl')
        })
      })
    },

    // 删除图片
    handleRemoveImage() {
      this.formData.imgUrl = ''
    },

    // PDF上传
    handlePdfChange(file) {
      const isPdf = file.raw.type === 'application/pdf'
      if (!isPdf) {
        this.$message.error('只支持pdf格式的文件')
        return
      }

      API.signValue({ directory: 'pushBanner/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'pushBanner/')
        formData.append('signValue', data)
        formData.append('file', file.raw)
        API.uploadUniversalFile(formData).then(result => {
          this.formData.pdfUrl = result.data
          this.formData.pdfName = file.name
          this.formData.pdfSize = (file.size/1024/1024).toFixed(2)
        })
      })
    },

    // 提交表单
    handleSubmit() {
      this.$refs.bannerForm.validate(valid => {
        if (!valid) return
        this.submitLoading = true
        const params = { ...this.formData }
        API.editLaunchBanner(params).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.$message.success('操作成功')
          this.dialogVisible = false
          this.getList()
        }).finally(() => {
          this.submitLoading = false
        })
      })
    },

    // 对话框关闭
    handleDialogClose() {
      this.$refs.bannerForm.resetFields()
      this.formData = {
        id: null,
        bannerType: 0,
        bannerName: '',
        imgUrl: '',
        linkType: 1,
        linkUrl: '',
        pdfUrl: '',
        pdfName: '',
        status: 1
      }
    },

    // 分页
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNumber = 1
      this.getList()
    },
    handlePageChange(page) {
      this.pagination.pageNumber = page
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-config {
  .filter-bar {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
  }

  .footer {
    margin-top: 20px;
    text-align: right;
  }

  .image-preview {
    position: relative;
    width: 300px;
    height: 150px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .image-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      opacity: 0;
      transition: opacity 0.3s;

      i {
        font-size: 20px;
        color: #fff;
        margin: 0 10px;
        cursor: pointer;

        &:hover {
          color: #99c41c;
        }
      }
    }

    &:hover .image-mask {
      opacity: 1;
    }
  }

  .upload-placeholder {
    line-height: 20px;
    width: 300px;
    height: 150px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: border-color 0.3s;

    &:hover {
      border-color: #99c41c;
    }

    i {
      font-size: 28px;
      color: #8c939d;
      margin-bottom: 8px;
    }

    div {
      font-size: 14px;
      color: #8c939d;
    }
  }

  .upload-tip {
    font-size: 13px;
    color: #909399;
    margin-top: 5px;
    line-height: 20px;
  }
}
</style>
